import { render, staticRenderFns } from "./AIBuilderPopup.vue?vue&type=template&id=1823d9f4&scoped=true&"
import script from "./AIBuilderPopup.vue?vue&type=script&lang=js&"
export * from "./AIBuilderPopup.vue?vue&type=script&lang=js&"
import style0 from "./AIBuilderPopup.vue?vue&type=style&index=0&id=1823d9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823d9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1823d9f4')) {
      api.createRecord('1823d9f4', component.options)
    } else {
      api.reload('1823d9f4', component.options)
    }
    module.hot.accept("./AIBuilderPopup.vue?vue&type=template&id=1823d9f4&scoped=true&", function () {
      api.rerender('1823d9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/AIBuilderPopup.vue"
export default component.exports